import UserGroupService from '../../services/userGroup'

export const ACTION_LOAD_ROLES = 'ACTION_LOAD_LIST_ROLES'

export const loadListRoles = () => {
  return async (dispatch) => {
    try {
      const res = await UserGroupService.getRoles()
      if (res.status === 200) {
        dispatch({
          type: ACTION_LOAD_ROLES,
          payload: mapRoleToDisplay(res.data)
        })
      }
    } catch (error) {
      // console.log(error)
    }
  }
}

const mapRoleToDisplay = (roles) => {
  const mapRoles = new Map()
  roles.forEach((role) => {
    const listRole = mapRoles.get(role.parentId)
    if (listRole) {
      listRole.push(role)
      mapRoles.set(role.parentId, listRole)
    } else {
      mapRoles.set(role.parentId, [role])
    }
  })
  let parentList = mapRoles.get(null)
  parentList = parentList.map((item) => {
    item.children = mapRoles.get(item.id + '')
    return item
  })
  parentList.forEach((parent) => {
    parent.children.forEach((child) => {
      child.children = mapRoles.get(child.id + '')
    })
  })
  return parentList;
}
